// extracted by mini-css-extract-plugin
export default {"hotspot":"Hotspot_hotspot__-aiQX","activeHotspot":"Hotspot_activeHotspot__kq5yJ"};